module.exports = __webpack_public_path__ + "static/media/info4.dbc25d2e.png";